import {
  Component,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import { safeJsonInput } from '../../../shared/_utils/safe-json-input';

/**
 * Controversy home page shell.
 */
@Component({
    selector: 'gtw-controversy-app',
    templateUrl: './controversy-app.component.html',
    styleUrls: ['./controversy-app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ControversyAppComponent {
  rowData: any = {};

  @Input('base-urls')
  set _base_urls(_: string) {}

  @Input('header-data')
  set _header_data(_: string) {}

  @Input('row-data')
  set _row_data(v: string) {
    const d = typeof v === 'string'
      ? safeJsonInput<any>(v, null, 'controversy-app.row-data')
      : v;
    this.rowData = d || {};
  }

  @Input('filter-params')
  set _filter_params(_: string) {}
}
